// ============================================================================
// Deal categories — ONE list for the whole platform.
//
// The walker feed filters, the retailer's deal/profile forms and the admin
// screens all import from here, so a category a retailer can pick is always a
// filter a walker can use (and vice versa). Before this file there were four
// hand-copied lists that had drifted apart: the feed matched on free text
// ("korting", "lunch", …) instead of on the category itself, which is how a
// Tech deal ended up under "Eten & Drinken", and "Tech" had no pill at all.
//
// Changing the list? Change it here only. The backend stores the label as-is
// in deals.category / retailers.category, so renaming a label means a data
// migration too (see LEGACY_ALIASES for how old values are folded in).
// ============================================================================

export const DEAL_CATEGORIES = [
  'Eten & Drinken',
  'Mode',
  'Beauty',
  'Tech',
  'Wonen',
  'Overig',
];

export const DEFAULT_CATEGORY = 'Overig';

// Values that exist in older data or older builds, mapped onto the canonical
// list. Matching is case- and whitespace-insensitive.
const LEGACY_ALIASES = {
  'dranken': 'Eten & Drinken',
  'eten': 'Eten & Drinken',
  'eten en drinken': 'Eten & Drinken',
  'food': 'Eten & Drinken',
  'horeca': 'Eten & Drinken',
  'fashion': 'Mode',
  'kleding': 'Mode',
  'electronica': 'Tech',
  'elektronica': 'Tech',
  'technology': 'Tech',
  'wonen & sport': 'Wonen',
  'interieur': 'Wonen',
};

const key = (s) => String(s || '').trim().toLowerCase().replace(/\s+/g, ' ');

const CANONICAL = new Map(DEAL_CATEGORIES.map((c) => [key(c), c]));

// Canonical label for whatever is stored on a deal or shop. Unknown or empty
// values fall into "Overig", so every deal is reachable through exactly one
// category filter.
export function normalizeCategory(raw) {
  const k = key(raw);
  if (!k) return DEFAULT_CATEGORY;
  return CANONICAL.get(k) || LEGACY_ALIASES[k] || DEFAULT_CATEGORY;
}

export function isKnownCategory(raw) {
  return CANONICAL.has(key(raw));
}
